import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { makeStyles } from '@material-ui/styles';
import { Typography, Box, Fab } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 0,
    paddingBottom: 0,
    width: '100%',
  },
  iconMargin: {
    marginLeft: theme.spacing(1),
  },
  subTitle: {
    ...theme.typography.h2,
  },
  crumb: {
    ...theme.typography.h3,
    color: theme.palette.text.secondary,
  },
  fab: {
    position: 'fixed',
    top: 74,
    right: 32,
    zIndex: theme.zIndex.drawer - 100,
  },
}));

const PageHeader = (props) => {
  const { className, title, titleComponent, subTitle, fab, icon, subTitle2, actionHref, actionFab, action, ...rest } =
    props;

  const matchesSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Box display="flex">
        <Box flexGrow={1}>
          <Typography component="h2" gutterBottom variant={matchesSmall ? 'h3' : 'h2'}>
            {t(title)}
          </Typography>
        </Box>
        {titleComponent && <Box>{titleComponent}</Box>}
      </Box>
      <Typography align="center" component="h2" variant="subtitle1">
        {t(subTitle)}
      </Typography>
      {subTitle2 && (
        <Typography align="center" component="h2" variant="subtitle1">
          {t(subTitle2)}
        </Typography>
      )}

      {actionFab && actionHref && (
        <span className={classes.fab}>
          {_.isFunction(actionHref) ? (
            <Fab color="primary" onClick={actionHref} variant={action ? 'extended' : 'circular'}>
              {icon}
              <div className={classes.iconMargin}>{t(action)}</div>
            </Fab>
          ) : (
            <Fab color="primary" component={RouterLink} to={actionHref} variant={action ? 'extended' : 'circular'}>
              {icon}
              <div className={classes.iconMargin}>{t(action)}</div>
            </Fab>
          )}
        </span>
      )}
      <span className={classes.fab}>{fab}</span>
    </div>
  );
};

PageHeader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  titleComponent: PropTypes.node,
  subTitle: PropTypes.string,
  subTitle2: PropTypes.string,
  icon: PropTypes.node,
  action: PropTypes.string,
  actionHref: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  actionFab: PropTypes.bool,
  fab: PropTypes.node,
};
PageHeader.defaultProps = {
  className: undefined,
  title: undefined,
  titleComponent: undefined,
  subTitle: undefined,
  subTitle2: undefined,
  action: undefined,
  icon: undefined,
  fab: undefined,
  actionHref: undefined,
  actionFab: false,
};

export default PageHeader;
